import { render, staticRenderFns } from "./image-viewer.vue?vue&type=template&id=5581e524&"
import script from "./image-viewer.vue?vue&type=script&lang=js&"
export * from "./image-viewer.vue?vue&type=script&lang=js&"
import style0 from "./image-viewer.vue?vue&type=style&index=0&id=5581e524&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../resource-manage/node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports